export const BetActionTypes = {
    FETCH_ACCORDION_HASH_START: "FETCH_ACCORDION_HASH_START",
    FETCH_COUNTRY_START: "FETCH_COUNTRY_START",
    FETCH_CLUB_START: "FETCH_CLUB_START",
    FETCH_CONTINENT_START: "FETCH_CONTINENT_START",
    FETCH_LEAGUE_START: "FETCH_LEAGUE_START",
    TOP_NAV_TRIGERRED_START: 'TOP_NAV_TRIGERRED_START',
    FETCH_FIXTURE_START: "FETCH_FIXTURE_START",
    FETCH_TIMING_RANGE_START: 'FETCH_TIMING_RANGE_START',
    FETCH_FIXTURE_ODDS_START: "FETCH_FIXTURE_ODDS_START",
    FETCH_LEAGUE_NAMES_START: "FETCH_LEAGUE_NAMES_START",
    FETCH_UPCOMING_GAMES_START: 'FETCH_UPCOMING_GAMES_START',
    REMOVE_LEAGUE_START: 'REMOVE_LEAGUE_START',
    BET_FRAME_HIDDEN: 'BET_FRAME_HIDDEN',
    POST_BET_START: 'POST_BET_START',
    POST_BET_SUCCESS: 'POST_BET_SUCCESS',
    POST_BET_FAILURE: 'POST_BET_FAILURE',
    FETCH_MY_BET_START: 'FETCH_MY_BET_START',
    FETCH_MY_BET_SUCCESS: 'FETCH_MY_BET_SUCCESS',
    FETCH_MY_BET_FAILURE: 'FETCH_MY_BET_FAILURE',
    FETCH_BOOKED_CODE_START: 'FETCH_BOOKED_CODE_START',
    FETCH_BOOKED_CODE_SUCCESS: 'FETCH_BOOKED_CODE_SUCCESS',
    FETCH_BOOKED_CODE_FAILURE: 'FETCH_BOOKED_CODE_FAILURE',
    FETCH_COUPON_ID_START: 'FETCH_COUPON_ID_START',
    FETCH_COUPON_ID_SUCCESS: 'FETCH_COUPON_ID_SUCCESS',
    FETCH_COUPON_ID_FAILURE: 'FETCH_COUPON_ID_FAILURE',
    
    FETCH_ACCORDION_HASH_SUCCESS: "FETCH_ACCORDION_HASH_SUCCESS",
    FETCH_COUNTRY_SUCCESS: "FETCH_COUNTRY_SUCCESS",
    FETCH_CLUB_SUCCESS: "FETCH_CLUB_SUCCESS",
    FETCH_CONTINENT_SUCCESS: "FETCH_CONTINENT_SUCCESS",
    FETCH_LEAGUE_SUCCESS: "FETCH_LEAGUE_SUCCESS",
    FETCH_FIXTURE_SUCCESS: "FETCH_FIXTURE_SUCCESS",
    FETCH_FIXTURE_ODDS_SUCCESS: "FETCH_FIXTURE_ODDS_SUCCESS",
    FETCH_LEAGUE_NAMES_SUCCESS: "FETCH_LEAGUE_NAMES_SUCCESS",
}